<template>
    <div class="notes wrapper">
        <h6 class="dark fs-small bold"></h6>

        <div class="my-3">
            <ul v-if="getEventNotes">
                <li class="d-flex mb-2 relative" v-if="event.product && event.product.internalNote">{{event.product.internalNote}}</li>
                <li class="d-flex mb-2 relative" v-for="note in getEventNotes">
                    <div class="flex-all" @mouseenter="showActions" @mouseleave="hideActions">
                        <i class="ico-alert color-6 largest"></i>
                        {{ note.note }}

                        <transition name="fade">
                            <div class="actions" v-if="actions">
                                <i class="ico-edit pointer larger medium" @click="editNote(note)"></i>
                                <i class="ico-delete pointer larger medium" @click="deleteNote(note)"></i>
                            </div>
                        </transition>
                    </div>
                </li>
            </ul>
            <div v-else>
                You don't have notes.
            </div>
        </div>

        <div class="new dark pointer d-flex align-items-center" @click="addNote">
            <span class="ico-add color-1 mr-1 rounded-circle border-color-1 p-1 addNoteIcon"></span>
            Add note
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        props: {
            event: Object
        },
        data: function() {
            return {
                actions: false,
            }
        },
        computed: {
            ...mapGetters([
                'getEventNotes',
                'account',
            ]),
        },
        methods: {
            ...mapActions([
                'openModal',
                'setSelectedNote',
                'deleteEventNote',
            ]),
            showActions: function() {
                this.actions = true;
            },
            hideActions: function() {
                this.actions = false;
            },
            deleteNote: function(note) {
                this.setSelectedNote(note);

                this.deleteEventNote({
                    supplierId: this.account.supplierId,
                    eventNote: note
                });
            },
            addNote: function() {
                this.openModal('NoteAdd');
            },
            editNote: function(note) {
                this.setSelectedNote(note);
                this.addNote();
            },
        },
    }
</script>


<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .actions {
        background: $lightest;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        padding-left: 0.75rem;
        padding-bottom: 0.1rem;
    }

    .addNoteIcon{
        //fix the plus sign not being centered
        line-height: 0.6rem;
    }
</style>



// WEBPACK FOOTER //
// EventNotes.vue?cf2cadea